var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeSuppliesFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "office-supplies-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875@20230203",
    transform: "translate(-1501.000000, -123.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(1501.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "office-supplies-fill",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5833333,16.9615833 C22.5498316,16.9615833 23.3333333,17.745085 23.3333333,18.7115833 L23.3333333,23.9615833 L19.8333333,22.6490833 L16.3333333,23.9615833 L16.3333333,18.7115833 C16.3333333,17.745085 17.116835,16.9615833 18.0833333,16.9615833 L21.5833333,16.9615833 Z M5.97625,21.0274167 L9.98491668,16.3508333 C11.1885666,17.1038743 12.5801975,17.5021763 14,17.5 C14.3905983,17.5001104 14.7806303,17.4702729 15.1666667,17.41075 L15.1666667,23.9166667 L7.30508332,23.9166667 C6.621718,23.9166667 6.00087801,23.5188498 5.71528753,22.8980227 C5.42969705,22.2771956 5.53160696,21.5469227 5.97625,21.028 L9.98491668,16.3508333 L5.97625,21.0274167 Z M21.5833333,18.7121667 L18.0833333,18.7121667 L18.0833333,21.4363333 L19.8333333,20.7806667 L21.5833333,21.4369167 L21.5833333,18.7121667 Z M14,4.08333332 C17.22175,4.08333332 19.8333333,6.69491665 19.8333333,9.91666668 C19.8333333,13.1384167 17.22175,15.75 14,15.75 C10.77825,15.75 8.16666668,13.1384167 8.16666668,9.91666668 C8.16666668,6.69491668 10.77825,4.08333332 14,4.08333332 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSuppliesFill);
export default __webpack_public_path__ + "static/media/office-supplies-fill.f739f49bf93935fbdd7a0256333a9ae6.svg";
export { ForwardRef as ReactComponent };